import React from 'react'

import { connect } from "react-redux"

import { Redirect } from 'react-router-dom'

import Routes from '../routing/Routes'

// if the component is accessing the store then we must use withRouter Higher order component to inject in the routing functionality
// without withRouter and with connect routing doesn't work
// withRouter not needed if connect is not used here
import { withRouter } from 'react-router'

import '../css/main.css'

class Main extends React.Component {
  render() {
    return (
      <div className="main-content">
        <div className="sidebar-space">
          {this.props.auth.hasSessionTimedOut === true && this.props.location.pathname !== '/login' && <Redirect to='/login' />}
          {this.props.auth.hasCheckedForUserToken && <Routes />}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  let { auth } = state
  return { auth }
}

export default withRouter(connect(mapStateToProps)(Main))


// WEBPACK FOOTER //
// ./src/container/Main.js